// @flow
/** @jsx h */
import Button from 'preact-material-components/Button';
import Style from './style.css';
import { styled } from 'goober';
import Spinner from './Spinner';

type CustomButtonProps = {
  name: string,
  id: string,
  onClick?: any,
  disable?: boolean,
  loading?: boolean,
  style?: Record<string, any>,
  className?: string,
};

const CustomButtonContainer = styled('div')`
  text-align: center;
`;

export default function CustomButton(props: CustomButtonProps) {
  const { name, id, disable, onClick, loading, style = {}, className } = props;
  return (
    <CustomButtonContainer>
      <Button
        type='submit'
        disabled={disable}
        className={`${
          !loading ? Style.buttonStyle : Style.loadingButtonStyle
        } ${className ? className : ''}`}
        id={id}
        onClick={loading ? () => {} : onClick}
        style={{
          textTransform: 'none',
          ...style,
        }}
      >
        {!!loading && (
          <Spinner
            style={{
              position: 'relative',
              left: '-35px',
              marginRight: '-25px',
            }}
          />
        )}
        {name}
      </Button>
    </CustomButtonContainer>
  );
}



// WEBPACK FOOTER //
// ./components/checkoutWidget/CustomButton.js